"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _basis = require("basis");

var _ = require("./..");

var _theme = require("../../theme");

// @ts-ignore
var Header = function Header(props) {
  var children = props.children,
      error = props.error,
      showSecureMessage = props.showSecureMessage,
      textPath = props.textPath,
      additionalErrorMessage = props.additionalErrorMessage;
  var theme = (0, _theme.useTheme)();
  var text = (0, _.useTextContent)(textPath);
  return /*#__PURE__*/_react.default.createElement(_basis.Container, {
    margin: "0 0 6 0"
  }, /*#__PURE__*/_react.default.createElement(_basis.Grid, {
    rowsGap: "6"
  }, children && /*#__PURE__*/_react.default.createElement(_basis.Text, {
    as: "h2",
    margin: "0 0 2 0",
    textStyle: theme.headingSize,
    color: theme.headingColor
  }, children), error && /*#__PURE__*/_react.default.createElement(_.ErrorMessage, (0, _extends2.default)({}, error, {
    additionalErrorMessage: additionalErrorMessage
  })), text && textPath && /*#__PURE__*/_react.default.createElement(_basis.Text, null, /*#__PURE__*/_react.default.createElement(_.TextContent, {
    path: textPath
  })), showSecureMessage && /*#__PURE__*/_react.default.createElement(_.SecureMessage, null)));
};

exports.Header = Header;